  <!-- V1.4 退出重点关注审核不通过 -->
<template>
  <div class="exitSupervision">
    <div class="exitSupervisionBox">
      <div class="exitSupervision_top">
        <div class="exitSupervision_top_title">{{ supervisionNoPassData.title }}</div>
        <div class="exitSupervision_top_nav line_bottom">
          <div class="exitSupervision_top_people">审核人：{{ supervisionNoPassData.auditName }}</div>
          <div class="exitSupervision_top_time">审核时间： {{ supervisionNoPassData.auditTime | filtTime }}</div>
        </div>
        <div class="exitSupervision_top_remark">
          <div class="remark">审核意见</div>
          <div class="remark_font">
            <div class="remark_font_size">{{ supervisionNoPassData.auditMemo }}</div>
            <div class="remark_font_detele" v-show="isShowDetele" @click="showDetele">
              <span>申请详情</span>
              <img src="../../../../assets/integrity/ic_xl@3x.png" alt="">
            </div>
            <div class="remark_font_detele_time" v-show="!isShowDetele">
              <div class="remark_applicant">申请人：{{ supervisionNoPassData.applyName }}</div> 
              <div class="remark_time">发起时间： {{ supervisionNoPassData.applyTime | filtTime }}</div> 
            </div>
          </div>
        </div>
      </div>

      <div class="exitSupervision_bottom">
        <div class="result line_bottom">
          <div class="title">
            <div>企业评分信息</div>
          </div>
        </div>
        <div class="toBeRectified">
          <div class="companyName line_bottom">
            <div class="left">企业名称</div>
            <div class="right" @click="goTaskDetail">
              <span>{{ enterpriseDetailData.enterpriseName }}</span>
              <img src="../../../../assets/image/ic_jt_ck@2x.png" alt />
            </div>
          </div>
          <div class="jurisdiction line_bottom">
            <div class="left">所属辖区</div>
            <div class="right">{{ enterpriseDetailData.regionName }}</div>
          </div>
          <div class="supervisionDate line_bottom">
            <div class="left">进入重点关注日期</div>
            <!-- <div class="right" v-show='contentData.planTime'>{{'2019-11-18 15:30'|filtTime}}</div> -->
            <div class="right">{{ enterpriseDetailData.enteredTime | filtTime }}</div>
          </div>
          <div class="supervisionDate integrityIndex">
            <div class="left"><span>诚信指数</span></div>
            <div class="right">
              <span @click="goGradeDetail">评分详情</span>
              <img src="../../../../assets/image/ic_jt_ck@2x.png" alt />
            </div>
          </div>
          <div class="integrity_scored">
            <div class="integrity_scored_box">
              <div class="integrity_scored_current"><span class="current">{{ enterpriseDetailData.score || 0 }}</span> 分</div>
              <div class="integrity_scored_title">当前评分</div>
            </div>
            <div class="integrity_scored_box">
              <div class="integrity_scored_bringInto"><span class="bringInto">{{ enterpriseDetailData.enterScore || 0 }}</span> 分</div>
              <div class="integrity_scored_title">纳入评分</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom"> 
      <div class="status" @click="changeBtn">我知道了</div>
    </div>
    <toastItem :isShowToast="isShowToast" :remark="'处理成功'"></toastItem>
  </div>
</template>

<script>
    import api from '../../../../service/modules/integrity';
    import toastItem from '../../components/toast';

    export default {
        components: {
            toastItem
        },
        data () {
            return {
                isShowToast: false,
                isShowDetele: true,
                supervisionNoPassData: {},
                enterpriseDetailData: {}
            }
        },
        created () {
            this.getSupervisionNoPass();
        },
        methods: {
            getSupervisionNoPass () {
                api.supervisionNoPass({ taskId: this.$route.query.taskId }).then(res => {
                    if (res.ret === 0) {
                        this.supervisionNoPassData = res.data;
                        this.enterpriseDetailData = (res.data && res.data.enterpriseDetail) || {};
                    }
                })
            },
            showDetele () {
                this.isShowDetele = false;
            },
            /** 审核 */
            changeBtn () {
                api.taskKnow({ id: this.supervisionNoPassData.id }).then(res => {
                    if (res.ret === 0) {
                        // this.$toast('该条待办已标记为完成')
                        yyn.invokeJSB('closeWindow'); /** 跳转到tio首页 */
                        this.$Toast({
                            message: '处理成功',
                            icon: 'passed'
                        });
                    }
                });
            },
            /** 企业名称 */
            goTaskDetail () {
                this.$router.push({
                    path: 'enterpriseDetail',
                    query: {
                        enterpriseId: this.enterpriseDetailData.enterpriseId
                    }
                })
            },
            /** 诚信指数详情 */
            goGradeDetail () {
                this.$router.push({
                    path: 'scoreDetails',
                    query: {
                        id: this.enterpriseDetailData.enterpriseId
                    }
                })
            }
        },
        // 时间搓
        filters: {
            filtTime (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + "-";
                var M =
                    (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) + "-";
                var D =
                    (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
                var h =
                    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
                var m =
                    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
                    ":";
                var s =
                    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D + h + m + s;
                return strDate;
            }
        }
    }
</script>

<style lang="less" scoped>
.exitSupervision {
  color: #333;
  width: 100%;
  height: 100%;
  background-color: #fbfbfb;
  
  box-sizing: border-box;
  // margin-bottom: 74px;
  .exitSupervisionBox {
    position: relative;
    padding: 21px 12px;
    margin-bottom: 74px;
    height: 100%;
    // height: 100%;
    .exitSupervision_top {
      width: 100%;
      // height: 100%;
      background-color: #fff;
      float: left;
      box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
      border-radius:3px;
      margin-bottom: 16px;
      .exitSupervision_top_title {
        font-size:16px;
        font-weight:600;
        color: #333;
        padding: 16px;
      }
      .exitSupervision_top_nav {
        padding: 0 16px 16px 16px;
        color: #666;
        font-size:14px;
        font-weight:400;
        .exitSupervision_top_people{
          margin-bottom: 12px;
        }
        .exitSupervision_top_time {
  
        }
      }
      .exitSupervision_top_remark {
  
        .remark {
          padding: 16px 16px 12px 12px;
          font-size:14px;
          font-weight:600;
          color: #333;
        }
        .remark_font {
          margin: 0 16px 16px;
          background: #F8F8F8;
          color: #333333;
          font-weight:400;
          padding: 8px 16px;
          .remark_font_size {
            font-size:14px;
            line-height: 24px;
          }
          .remark_font_detele {
            margin: 12px 0 8px 0;
            color: #36B374;
            font-size:12px;
            font-weight:400;
            display: flex;
            justify-content: left;
            align-items: center;
            span{
              display: inline-block;
            }
            img{
              display: inline-block;
              width: 12px;
              height: 12px;
              margin-left: 4px;
            }
          }
          .remark_font_detele_time {
            color: #999999;
            font-size:12px;
            font-weight:400;
            .remark_applicant {
              margin: 8px 0;
            }
            .remark_time {
              margin-bottom: 6px;
            }
          }
        }
      }
    }
    .exitSupervision_bottom {
      width: 100%;
      // height: 100%;
      background-color: #fff;
      float: left;
      box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
      border-radius:3px;
      margin-bottom: 94px;
      .result {
        width: 100%;
        padding: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          font-size: 14px;
          color: #333;
          font-weight: 600;
          display: flex;
          justify-content: space-between;
        }
      }
      .toBeRectified {
        width: 100%;
        height: 100%;
        margin-bottom: 24px;
        .companyName,
        .jurisdiction,
        .supervisionDate {
          height: 62px;
          width: 100%;
          line-height: 62px;
          padding: 0 16px;
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          .left {
            color: #999;
          }
        }
        .jurisdiction{
          .right{
            width: 160px;
            text-align: right;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .companyName {
          line-height: center;
          .right{
            display: flex;
            justify-content: space-around;
            span{
              display: inline-block;
              width: 160px;
              text-align: right;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            img{
              display: inline-block;
              width: 12px;
              height: 12px;
              margin-left: 4px;
              margin-top: 24px;
            }
          }
        }
        .integrityIndex {
          height: 60px;
          width: 100%;
          line-height: 60px;
          padding: 0 16px;
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left{
            // display: flex;
            // align-items: center;
          }
          .right {
            span {
              float: left;
            }
            img {
              display: inline-block;
              float: right;
              width: 12px;
              height: 12px;
              margin-left: 4px;
              margin-top: 24px;
            }
          }
        }
        .integrity_scored {
          margin: 12px 16px 0px 16px;
          display: flex;
          justify-content: space-around;
          .integrity_scored_box {
            .integrity_scored_current {
              color: #36B374;
              font-size: 10px;
              span {
                font-size: 20px;
                font-weight:bold;
              }
  
            }
            .integrity_scored_bringInto {
              color: #FF4D4D;
              font-size: 10px;
              span {
                font-size: 20px;
                font-weight:bold;
              }
            }
            .integrity_scored_title {
              margin-top: 8px;
              color: #999999;
              font-size:12px;
              font-weight:400;
            }
          }
        }
      }
    }
  }
  .bottom {
    box-shadow:0px -2px 8px 0px rgba(0,0,0,0.03);
    width: 100%;
    height: 74px;
    background-color: #fff;
    padding: 12px;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .status {
      border-radius: 3px;
      width: 100%;
      height: 100%;
      line-height: 50px;
      text-align: center;
      background-color: #36b374;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
    }
    .saw {
      opacity: 0.5;
    }
  }
  .examinePicker {
      padding: 12px;
      .examinePickerTitle {
        padding: 8px 4px 0 4px;
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: bold;
      }

      .examineBtns::after {
        content: "";
        display: block;
        clear: both;
      }

      .examineBtns {
        padding: 0 4px;
        margin-bottom: 24px;

        > div {
          width: 64px;
          height: 28px;
          font-size: 12px;
          text-align: center;
          line-height: 28px;
          color: #36b374;
          border: 1px solid #36b374;
          border-radius: 2px;
          float: left;
        }

        > div.active {
          color: #fff;
          background-color: #36b374;
        }

        .throughExamine {
          margin-right: 12px;
        }
      }

      .examineMiddleBox {
        min-height: 75px;
        padding: 0 4px;
        .examineOpinionBox {
          margin-bottom: 16px;
          font-size: 14px;
          color: #666;
        }

        .notThroughExamineTitile {
          font-size: 16px;
          font-weight: bold;
          line-height: 20px;
          color: #333;

          > span {
            margin-left: 4px;
            font-size: 12px;
            font-weight: normal;
            color: #999;
          }
        }
        .throughExamineTextBox {
          margin-bottom: 24px;
          position:relative;
          .throughExamineText {
            margin-top: 10px;
            padding: 10px;
            height: 120px;
            border:none;
           resize: none;
            width: 94%;
            // overflow-y: scroll;
            font-size: 14px;
            line-height: 22px;
            color: #333333;
            background-color: #f5f5f5;
            border-radius: 4px;
          }
        }
      }

      .submitBtn {
        width: 100%;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #fff;
        background-color: #9bd9ba;
        border-radius: 3px;
        font-size: 16px;
        font-weight: 500;
      }

      .submitBtn.active {
        background-color: #36b374;
      }
      .cancelIcon {
      width: 40px;
      height: 40px;
      position: absolute;
      background: #fff;
      z-index: 99;
      right: 0;
      top: 0;
      div {
        width: 20px;
        height: 20px;
        margin-top: 12px;
      }
    }
  }
}
</style>
